'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber, formatCreditsShort } from '../utils/formatters';
import { BonusCreditsCountUp } from './BonusCreditsCountUp';
import { FaBolt } from './icons';

interface BonusCreditsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number | string;
  iconOnly?: boolean;
  muted?: boolean;
  compact?: boolean;
  iconClassName?: string;
  align?: 'center' | 'baseline';
  animateChange?: boolean;
}

export const BonusCredits: FC<BonusCreditsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false, compact = false, iconClassName, align = 'center', animateChange = false }) => {
  const format = compact ? formatCreditsShort : formatCreditsNumber;

  return (
    <span className={`inline-flex ${align === 'baseline' ? 'items-baseline' : 'items-center'} gap-1 ${className || ''}`}>
      {!iconOnly && (animateChange ? <BonusCreditsCountUp amount={amount} /> : format(amount))}
      {showIcon && <FaBolt className={`${iconClassName ?? (muted ? 'text-fuchsia-400/50' : 'text-fuchsia-400')} shrink-0`} size={iconSize} />}
    </span>
  );
};
